<template>
    <div class="modal fade" id="applyImplantConfirmModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" id="exampleModalLabel">Δήλωση εφαρμογής μοσχεύματος</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Εφαρμογή του μοσχεύματος;</p>
                </div>
                <div class="modal-footer">
                    
                    <button type="button" class="btn" data-bs-dismiss="modal" @click="cancelModal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                    <button type="submit" class="btn" @click="save"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Υποβολή</button>
                </div>
            </div>
        </div>
    </div>
    <div>
        <!-- Tabs Content -->
        <div class="d-flex mt-4">

            <!-- Main Content Area -->
            <div class="content-area" :class="{ 'shrink': implantShown, 'expand': !implantShown }">
                <div>
                    <div class="d-flex">
                        <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px"
                            class="form-label">
                            Αναζήτηση με:
                        </label>
                        <select name="institute_relations ms-2" style="max-width:30%" class="form-control"
                            v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                            <option value="" selected>Επιλέξτε...</option>
                            <option value="implant_name">Μόσχευμα</option>
                            <option value="category">Κατηγορία</option>
                            <option value="institution_name">Ίδρυμα Ιστών</option>
                            <option value="sec">Κωδικός SEC</option>
                            <option value="patient_amka">AMKA Ασθενούς</option>
                        </select>
                        <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue"
                            placeholder="Κριτήριο..." />
                        <button class="btn ms-2" @click="handleExport()">
                            <img src="../assets/images/excel16.png" alt="Excel" class="menu-img"
                                style="width:1.1em; margin-right:10px">
                            MS-Excel
                        </button>
                    </div>

                    <table class="table table-bordered table-hover table-striped">
                        <tr style="border-bottom: 2px solid gray; ">
                            <td></td>
                            <td style="padding-left:15px">Σύνολο: {{ totalCount }}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>

                        <thead class="table-light">
                            <tr>
                                <th @click="sortTable('id')" style="width:8%">
                                    ID
                                    <span v-if="sortKey === 'id'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('implant_name')">
                                    Μοσχευμα
                                    <span v-if="sortKey === 'implant_name'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('category')" style="width:8%">
                                    Κατηγορια
                                    <span v-if="sortKey === 'category'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('sec')">
                                    Κωδικος SEC
                                    <span v-if="sortKey === 'sec'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
       
                                <th @click="sortTable('apply_date')">
                                    Ημ/νια εφαρμογης
                                    <span v-if="sortKey === 'apply_date'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('patient_amka')" style="width:12%">
                                    AMKA ΑΣΘΕΝΟΥΣ
                                    <span v-if="sortKey === 'patient_amka'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('institution_name')">
                                    Ιδρυμα Ιστων
                                    <span v-if="sortKey === 'institution_name'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
  v-for="implant in implants" 
  :key="implant.id" 
  @click="showImplant(implant)"
  :class="{ active2: selectedRow?.id === implant.id }"
  @dblclick="openApplyModal(implant)"
>
    <td>
        <img
            src="../assets/images/implant16.png"
            alt="Applied Icon"
            class="menu-img"
            style="width:1em; margin-right:3px; margin-bottom:3px"
        />
        {{ implant.id }}
    </td>
    <td>{{ implant.implant_name }}</td>
    <td>{{ implant.category }}</td>
    <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
    <td>{{ formatLicenseExp(implant.apply_date) }}</td>
    <td>{{ implant.patient_amka }}</td>
    <td :title="implant.institution_name">{{ limitHos(implant.institution_name) }}</td>
</tr>

                        </tbody>
                    </table>
                    <nav aria-label="Page navigation" v-if="paginationLinks && paginationLinks.length > 1">
                        <ul class="pagination mt-4" >
                            <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index"
                                :class="{ active: paginationLink.active }">
                                <router-link
                                    :to="{ path: 'temp-saved-implants-hospital', query: { page: getPageFromUrl(paginationLink.url) } }"
                                    v-if="paginationLink.url">
                                    <span class="page-link" v-html="paginationLink.label"></span>
                                </router-link>
                                <span class="page-link" v-else v-html="paginationLink.label"></span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div> <!-- Implant Details -->
            <div class="implant_details" v-if="implantShown">
                <div class="d-flex align-items-center justify-content-between mb-4 mt-2 me-1">
                    <label class="fw-bolder mb-0 me-2" style="font-size: large; white-space: nowrap;">
                        Στοιχεία Μοσχεύματος
                    </label>
                    <div class="d-flex ms-auto">
                        <button class="btn me-2" @click="printPreview">
                            <img src="../assets/images/print.png" alt="Preview" class="menu-img" style="width: 1.1em;">

                        </button>
                        
                        <button class="btn" @click="closeDetails">
                            <img src="../assets/images/hide16.png" alt="Hide" class="menu-img" style="width: 1.1em;">
                        </button>
                    </div>
                </div>
                <h5 class="mb-4">{{ selectedImplant.implant_name }}</h5>
                <div class="implant-details-container">

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">ID</strong>
                        <div class="value-text">{{ selectedImplant.id }}</div>
                    </div>

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Κατηγορία</strong>
                        <div class="value-text">{{ selectedImplant.category }}</div>
                    </div>

                   

                    <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">
                        <div class="implant-detail shadow mb-2">
                            <strong class="label-text">ΑΜΚΑ Ασθενούς</strong>
                            <div class="value-text">{{ selectedImplant.patient_amka }}</div>
                        </div>

                        <div class="implant-detail shadow mb-2 ms-2">
                            <strong class="label-text">Ημ/νια Εφαρμογής</strong>
                            <div class="value-text">{{ formatLicenseExp(selectedImplant.apply_date) }}</div>
                        </div>

                    </div>


                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Κωδικός SEC</strong>
                        <div class="value-text">{{ selectedImplant.sec }}</div>
                    </div>

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Ίδρυμα Ιστών</strong>
                        <div class="value-text">{{ selectedImplant.institution_name }}</div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!-- Bootstrap Modal -->
    <div class="modal fade" id="printModal" tabindex="-1" aria-labelledby="printModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="printModalLabel">Προεπισκόπηση εκτύπωσης</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div id="printContent">
                        <!-- This is where the content for printing will go -->
                        <p>Παρακαλώ περιμένετε...</p>
                    </div>
                </div>
              
            </div>
        </div>
    </div>
    <div class="modal fade" id="applyModal" tabindex="-1" aria-labelledby="applyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="applyModalLabel">Δήλωση Eφαρμογής Mοσχεύματος</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
    <div class="d-flex mt-3 mb-2">
        <label class="col-md-4 mt-1">Κωδικός SEC:</label>
        <input 
            type="text" 
            maxlength="40" 
            class="form-control" 
            id="sec" 
            name="sec" 
            v-model="sec" 
            placeholder="Εισάγετε κωδικό SEC" 
            required
        />
    </div>
    <div class="d-flex mt-3 mb-2">
        <label class="col-md-4 mt-1">Κατηγορία:</label>
        <select 
            id="categoryId" 
            name="categoryId" 
            class="form-control" 
            v-model="selectedCategoryId" 
            placeholder="Επιλέξτε κατηγορία" 
            required
        >
            <option value="" selected>Επιλέξτε κατηγορία</option>
            <option 
                v-for="category in categories" 
                :key="category.id" 
                :value="category.id"
            >
                {{ category.category }}
            </option>
        </select>
    </div>
    <div class="d-flex mt-3 mb-2">
        <label class="col-md-4 mt-1">Επιλέξτε μόσχευμα:</label>
        <select 
            id="implant" 
            name="implant" 
            class="form-control" 
            v-model="implantId" 
            placeholder="Επιλέξτε μόσχευμα" 
            required
        >
            <option value="" selected>Επιλέξτε μόσχευμα</option>
            <option 
                v-for="implant in implants2" 
                :key="implant.id" 
                :value="implant.id"
            >
                {{ implant.implant }}
            </option>
        </select>
    </div>
    <div class="d-flex mt-3 mb-2">
        <label class="col-md-4 mt-1">Επιλέξτε Ίδρυμα ιστών:</label>
        <select 
            id="implant" 
            name="implant" 
            class="form-control" 
            v-model="instId" 
            placeholder="Επιλέξτε Ίδρυμα ιστών" 
            required
        >
            <option value="" selected>Επιλέξτε Ίδρυμα ιστών</option>
            <option 
                v-for="institute in institutes" 
                :key="institute.id" 
                :value="institute.id"
            >
                {{ institute.title }}
            </option>
        </select>
    </div>
   <!--  <div class="d-flex mt-3 mb-2">
        <label class="col-md-4 mt-1">Επιλέξτε Προμηθευτή:</label>
        <select 
            id="implant" 
            name="implant" 
            class="form-control" 
            v-model="provId" 
            placeholder="Επιλέξτε Προμηθευτή"
        >
            <option value="" selected>Επιλέξτε Προμηθευτή</option>
            <option 
                v-for="provider in providers" 
                :key="provider.id" 
                :value="provider.id"
            >
                {{ provider.title }}
            </option>
        </select>
    </div> -->
    <div class="d-flex mt-3 mb-2">
        <div class="d-flex flex-grow-1 me-3 col-md-6">
            <label class="mt-1">Ημ/νία εφαρμογής μοσχεύματος:</label>
            <input 
                type="date" 
                class="form-control" 
                id="applyDate" 
                name="applyDate" 
                v-model="applyDate" 
                placeholder="Επιλέξτε ημ/νία εφαρμογής" 
                required
            />
        </div>
        <div class="d-flex flex-grow-1">
            <label class="col-md-4 mt-2">ΑΜΚΑ:</label>
            <input 
                type="text" 
                maxlength="11" 
                class="form-control" 
                id="amka" 
                name="amka" 
                v-model="amka" 
                placeholder="Εισάγετε ΑΜΚΑ" 
                required
            />
        </div>
    </div>
</div>

                <div class="modal-footer justify-content-end">
                   
                    <div class="d-flex">
                        <button type="button" class="btn" data-bs-dismiss="modal"><img
                                src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img"
                                style="width:1.1em; margin-right:10px">Άκυρο</button>
                        <button type="button" class="btn ms-2" @click="saveModal"><img src="../assets/images/save16.png"
                                alt="Citrine Logo" class="menu-img"
                                style="width:1.1em; margin-right:10px">Υποβολή</button>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="infoModalLabel">Πληροφορία</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="d-flex">
                        <p>Αναζητήστε το μόσχευμα που θέλετε να δηλώσετε, κάντε διπλό κλικ και συμπληρώστε τη φόρμα
                            δήλωσης.</p>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <button type="button" class="btn" data-bs-dismiss="modal" style="background-color: #6DB4E3; color:white; min-width:80px; shadow:0">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { getNotUsed, downloadExportInstall, downloadFile, downloadExportNotUsed, fetchUserInfo, getInstitutions } from "../services/institutions";
import { deleteHospitalById, downloadExportHospitals, getHospitals, getHospitalsAll, getHospitalsForInstitute, postHospital, getHospitalAllTemp, downloadExportHospitalAllTemp } from "@/services/hospitals";
import { getGrafts, getGraftCategories, postCategory, postImplant, actImplant, deleteRelationsForImplant, instToHosp, useImplant, getImplantBySec, importImplantStatement } from "@/services/grafts";
import { useToast } from "vue-toastification";
import apiClient from "@/services/api";
import * as XLSX from 'xlsx';
import { actProvider, deleteRelationsForProvider, getCountries, getSuppliers, postProvider } from "@/services/suppliers";
import { getProvidersForInstitute } from "@/services/provider";

export default {
    data() {
        return {
            totalCount: 0,
            applyDate: "",
            selectedHospitalId: "",
            selectedHospitalAfm: null,
            searchField: "",
            searchValue: "",
            implants: [],
            hospitals: [],
            installedImplants: [],
            notUsedImplants: [],
            usedImplants: [],
            expiredImplants: [],
            paginationLinks: [],
            page: 1,
            selectedInsituteId: "0",
            selectedImplant: null,
            sortKey: "id",
            sortOrder: "desc",
            selectedField: "",
            implantShown: false,
            selectedRow: null,
            categories: [],
            providers: [],
            institutes: [],
            implants2: [],
            selectedCategoryId: "",
            implantId: "",
            amka: "",
            sec: "",
            instId: "",


        };
    },
    computed: {
        isFormValid() {
            return (
                this.amka.length === 11 &&
                this.sec.length === 40 &&
                this.selectedCategoryId !== "" &&
                this.implantId !== "" &&
                this.instId !== "" &&
                this.applyDate !== ""
            );
        },
    },
    methods: {
        saveModal() {
            if (this.sec.length != 40) {
                useToast().error('Το πεδίο sec πρέπει να είναι ακριβώς 40 ψηφία');
                return;
            }
            if (this.selectedCategoryId == '') {
                useToast().error('Το πεδίο κατηγορία είναι απαραίτητο');
                return;
            }
            if (this.implantId == '') {
                useToast().error('Το πεδίο μόσχευμα είναι απαραίτητο');
                return;
            }
            if (this.instId == '') {
                useToast().error('Το πεδίο ίδρυμα ιστών είναι απαραίτητο');
                return;
            }
            if (this.applyDate == '') {
                useToast().error('Το πεδίο ημ/νία εφαρμογής είναι απαραίτητο');
                return;
            }
            const date = new Date();
            const applyInDate = new Date(this.applyDate);
            if (applyInDate > date) {
                useToast().error('Η ημερομηνία εφαρμογής δεν μπορεί να είναι μεταγενέστερη της σημερινής.');
                return;
            }
            if (!this.implantId) {
                useToast().error('Πρέπει να επιλέξετε μόσχευμα');
                return;
            }
            if (this.amka.length != 11) {
                useToast().error('Το πεδίο ΑΜΚΑ πρέπει να είναι ακριβώς 11 ψηφία');
                return;
            }
            $("#applyImplantConfirmModal").modal('show');
            $("#applyModal").modal('hide');
        },
        cancelModal() {
            $("#applyImplantConfirmModal").modal('hide');
            $("#applyModal").modal('show');
        },
        async tempSave() {
            const hospId = this.selectedHospitalId;
            const applyDate = this.applyDate;
            if (hospId == '') {
                useToast().error('Πρέπει να επιλέξετε μονάδα εφαρμογής');
            }
            if (applyDate == '') {
                useToast().error('Πρέπει να επιλέξετε ημ/νία εφαρμογής μοσχεύματος');
            }
            if (!this.selectedImplant) {
                useToast().error('Πρέπει να επιλέξετε μόσχευμα');
            }
            const response = await instToHosp({ id: this.selectedImplant.id, hospid: hospId, todate: applyDate, istemp: 1 });
            if (response.data.success) {
                $("#applyModal").modal('toggle');
                useToast().success('Επιτυχής δήλωση εφαρμογής μοσχεύματος');
            } else {
                useToast().error('Αποτυχία δήλωση εφαρμογής μοσχεύματος');
            }
        },
        async save() {
            const userInfo = await fetchUserInfo();
            const secResponse = await getImplantBySec({seccode: this.sec});
            if (secResponse.data.success && secResponse.data.data) {
                const response = await useImplant({ id: secResponse.data.data, hospid: userInfo.data.hospital.id, amka: this.amka, apply_date: this.applyDate, istemp: 0, apply_status: 1 });
                if (response.data.success) {
                    $("#applyImplantConfirmModal").modal('hide');
                    useToast().success('Επιτυχής δήλωση εφαρμογής μοσχεύματος');
                } else {
                    useToast().error(response.data.message);
                }
            } else {
                const response = await importImplantStatement({
                    id: 0,
                    implant_id: this.implantId,
                    institude_id: this.instId,
                    provider_id: this.provId,
                    hosp_id: userInfo.data.hospital.id,
                    sec: this.sec,
                    origin: 0,
                    transtype: 0,
                    inst_recvdate: this.applyDate,
                    custom: 0,
                    proto_num: 0,
                    proto_date: null,
                    status: 1,
                    apply_date: this.applyDate,
                    amka: this.amka,
                    apply_hospital_id: userInfo.data.hospital.id,
                    prov_hospital_id: userInfo.data.hospital.id,
                    apply_status: 1,
                    exp_date: null,
                    istemp_inst: 0,
                    istemp_hosp: 0
                });
                if (response.data.success) {
                    useToast().success('Επιτυχής δήλωση εφαρμογής μοσχεύματος');
                    $("#applyImplantConfirmModal").modal('hide');
                } else {
                    useToast().error(response.data.message);
                }
            }
            const implants = (await getHospitalAllTemp({ hospid: userInfo.data.hospital.id })).data;
            this.implants = implants.data.results.data;
            this.paginationLinks = implants.data.results.links;
            this.totalCount = implants.data.count;
        },
        limitSec(sec) {
            if (sec && sec.length > 10) {
                return sec.substring(0, 10) + '...';
            }
            return sec;
        },
        limitHos(hos) {
            if (hos && hos.length > 30) {
                return hos.substring(0, 30) + '...';
            }
            return hos;
        },
        async openApplyModal(implant) {
    this.sec = implant.sec;
    this.selectedCategoryId = implant.catid || ''; // Assuming implant has `category_id`
    this.implantId = implant.implant_id;
    this.instId = implant.institude_id || ''; // Assuming implant has `institution_id`
    this.provId = implant.provider_id || ''; // Assuming implant has `provider_id`
    this.applyDate = implant.apply_date ? implant.apply_date.split('T')[0] : ''; // Format date if needed
    this.amka = implant.patient_amka;

    // Open the modal
    $("#applyModal").modal('toggle');

    // Fetch hospitals if necessary
    const userInfo = await fetchUserInfo();
    const hospitalsResponse = await getHospitalsForInstitute({ hospid: userInfo.data.hospital.id });
    if (hospitalsResponse.data.success) {
        this.hospitals = hospitalsResponse.data.data;
    }
},
        printPreview() {
            $("#printModal").modal('toggle');

            apiClient.get('/eomws/print-implant-hospital/' + this.selectedImplant.id, {
                responseType: 'text', // Expect text to handle HTML responses
                headers: {
                    "Accept": "text/html", // Expect an HTML response
                },
            })
                .then((response) => {
                    // Close the modal
                    setTimeout(() => {
                        $("#printModal").modal('hide');
                    }, 1000);

                    // Check the content type of the response
                    const contentType = response.headers['content-type'];
                    if (contentType.includes('text/html')) {
                        // Create an iframe element
                        const iframe = document.createElement('iframe');
                        iframe.style.position = 'absolute';
                        iframe.style.top = '0';
                        iframe.style.left = '0';
                        iframe.style.width = '0';
                        iframe.style.height = '0';
                        iframe.style.border = 'none';
                        document.body.appendChild(iframe);

                        // Write the printable content into the iframe
                        const iframeDoc = iframe.contentWindow.document;
                        iframeDoc.open();
                        iframeDoc.write(response.data); // Write the HTML content to the iframe
                        iframeDoc.close();

                        // Wait for the content to load, then print
                        iframe.onload = () => {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();

                            // Clean up after printing
                            setTimeout(() => {
                                document.body.removeChild(iframe); // Remove the iframe after printing
                            }, 1000); // Delay to ensure the print dialog is completed
                        };
                    } else {
                        console.error('Unexpected content type:', contentType);
                    }
                })
                .catch((error) => {
                    // Close the modal and log the error
                    $("#printModal").modal('toggle');
                    console.error('Error in print preview:', error);
                });
        },
        download() {
            if (!this.selectedImplant.file_name) {
                useToast().error('Δεν υπάρχει αρχείο!');
            } else {
                downloadFile(this.selectedImplant.id, this.selectedImplant.file_name, this.selectedImplant.mime_type);
            }
        },
        closeDetails() {
            this.implantShown = false;
        },
        onChangeHospital() {
            let hospital = null;
            for (let i = 0; i < this.institutions.length; i++) {
                if (this.institutions[i].id == $("#hospital").val()) {
                    hospital = this.institutions[i];
                }
            }
            if (hospital) {
                this.selectedHospitalAfm = hospital.afm;
            } else {
                this.selectedHospitalAfm = null;
            }
        },
        showImplant(implant) {
            this.selectedImplant = implant;
            this.implantShown = true;
            this.selectedRow = implant;
        },
        sortTable(column) {
            if (this.sortKey === column) {
                // Reverse order if the column is already sorted
                this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = column;
                this.sortOrder = "asc";
            }
            this.handleRefresh();
        },
        getPageFromUrl(url) {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        },
        resetInstitute() {
            this.selectedInsituteId = "0";
            this.handleRefresh();
        },
        async handleRefresh() {
            let params = {
                sortBy: this.sortKey,
                sortOrder: this.sortOrder,
                page: this.page
            };
            if (this.searchField != "" && this.searchValue != "") {
                params[this.searchField] = this.searchValue;
            }
            const userInfo = await fetchUserInfo();
            params.hospid = userInfo.data.hospital.id;
            const implants = (await getHospitalAllTemp(params)).data;
            this.implants = implants.data.results.data;
            this.paginationLinks = implants.data.results.links;
            this.totalCount = implants.data.count;

            const implantsResponse = await getGrafts({catid: this.selectedCategoryId});
            const providersResponse = await getProvidersForInstitute({instid: this.instId});
            if (providersResponse.data.success) {
                this.providers = providersResponse.data.data;
            }
            if (implantsResponse.data.success) {
                this.implants2 = implantsResponse.data.data;
            }
        },
        async handleExport() {
            let params = {
                sortBy: this.sortKey,
                sortOrder: this.sortOrder,
                page: this.page
            };
            if (this.searchField != "" && this.searchValue != "") {
                params[this.searchField] = this.searchValue;
            }
            const userInfo = await fetchUserInfo();
            params.hospid = userInfo.data.hospital.id;
            downloadExportHospitalAllTemp(params);
        },
        formatLicenseExp(date) {
            if (date == null) { return ''}
            return new Date(date).toLocaleDateString("el-GR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        openInfoModal() {
            $("#infoModal").modal('show');
        }
    },
    async mounted() {
        const userInfo = await fetchUserInfo();
        const implants = (await getHospitalAllTemp({ hospid: userInfo.data.hospital.id })).data;
        const categoriesResponse = await getGraftCategories();
        if (categoriesResponse.data.success) {
            this.categories = categoriesResponse.data.data;
        }
        const institutionsResponse = await getInstitutions();
        if (institutionsResponse.data.success) {
            this.institutes = institutionsResponse.data.data;
        }
        this.implants = implants.data.results.data;
        this.paginationLinks = implants.data.results.links;
        this.totalCount = implants.data.count;
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                const page = newRoute.query.page || 1; // Default to page 1 if not in URL
                this.page = page;
                this.handleRefresh();
            }
        },
        selectedInsituteId: {
            immediate: true,
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        searchField: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        searchValue: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        selectedCategoryId: {
            immediate: true,
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        instId: {
            immediate: true,
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
    }
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
    width: 100%;
}

.btn {
    background-color: #f6f6f6;
}

.btn:hover,
.btn-md:hover {
    background-color: #ececec;
}

.btn-md {
    background-color: white;
    border: none;
}

.page-container {
    display: flex;
    width: 100%;
    height: 100%;
    /* Ensures the layout fits the screen height */
    overflow: hidden;
    /* Prevent overflow when zoomed */
}

.content-area {
    flex: 1;
    /* Default flex value */
    transition: all 0.3s ease-in-out;
    min-width: 0;
    /* Prevent the content from overflowing */
    padding-right: 10px;
    /* Add slight padding to avoid overlap */
}

.content-area.shrink {
    flex: 0.68;
    /* Slightly smaller to provide more space for details */
}

.implant_details {
    flex: 0.32;
    /* Adjusted to match shrink */
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    padding-left: 10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left: 10px;
    min-width: 280px;
    /* Ensure the details panel doesn't shrink too much */
}

.implant-details-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}

.implant-detail {
    background: #fff;
    border-radius: 15px;
    box-shadow: 3px 3px 15px #c2c2c2;
    padding: 8px;
    width: calc(100% - 20px);
    /* Default to full width */
    padding-left: 10px;
    font-size: medium;
}

.label-text {
    font-size: 0.9rem;
    color: #6c757d;
    /* Muted text for the label */
    margin-bottom: 5px;
    display: block;
    /* Ensure label appears above */
}

.value-text {
    font-size: 1rem;
    font-weight: bold;
    color: #000;
}

.table {
    width: 100%;
    /* Ensure table stays within bounds */
    table-layout: fixed;
    /* Prevent columns from expanding uncontrollably */
    word-wrap: break-word;
    /* Handle long text gracefully */
}

th,
td {
    text-align: left;
    vertical-align: middle;
    padding: 8px;
}


.content-area.w-100 {
    width: 100%;
    transition: width 0.3s ease-in-out;
}

.label-text,
.value-text {
    font-size: small;
}

.active2 {
    background-color: #ffefbb;
    /* Light blue background */
    font-weight: bold;
    /* Make the text bold */
}

.modal-header {
    background-color: #6DB4E3;
}

.modal-title {
    color: white;
}

.modal-content {
    border: none;
    margin-top: 10vw;
}
</style>